import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

export type AccordionCallbackFunction = () => any | never;
export interface IAccordionCallbackObject {
	fnCallback: AccordionCallbackFunction;
	$ctx: JQuery;
}

enum States {
	Hover = 'state-o-accordion--hover',
	Open = 'state-o-accordion--open',
	ItemOpen = 'state-m-accordion-item--open',
}

enum Selectors {
	AccordionItem = '.js-m-accordion-item',
	AccordionItemCollapse = '.js-m-accordion-item__collapse',
	Button = '.js-m-accordion-item__button',
	Video = '.js-m-video',
	VideoTeaser = '.js-m-video-teaser__video',
}

// The @Component decorator will connect the class with `data-g-name="Accordion"` elements.
@Component('Accordion')
export class Accordion extends GondelJqueryComponent {
	private fnCallbacksOpen: IAccordionCallbackObject[] = [];
	private fnCallbacksClose: IAccordionCallbackObject[] = [];
	public start() {
		const $buttons = this.$ctx.find(Selectors.Button);
		const $collapsedItem = this.$ctx.find(Selectors.AccordionItemCollapse);

		$collapsedItem.on('shown.bs.collapse', (ev: JQuery.Event) => {
			this.openAccordionItem(ev);
		});

		$collapsedItem.on('hidden.bs.collapse', (ev: JQuery.Event) => {
			this.closeAccordionItem(ev);
		});
		// hover classes handled in JS because the focused element
		// gets black and the other elements will grey-out.
		$buttons.on('mouseover', () => {
			this.$ctx.addClass(States.Hover);
		});

		$buttons.on('mouseout', () => {
			this.$ctx.removeClass(States.Hover);
		});
	}

	public sync() {
		this.checkIfItemIsOpen();
	}

	public registerCallback(fnCallback, state, $ctx) {
		state === 'open'
			? this.fnCallbacksOpen.push({ fnCallback, $ctx })
			: this.fnCallbacksClose.push({ fnCallback, $ctx });
	}

	private checkIfItemIsOpen() {
		const $items = this.$ctx.find(Selectors.AccordionItem);
		$.each($items, (index, item) => {
			const $item = $(item);
			if ($item.hasClass(States.ItemOpen)) {
				this.executeCallbacks($item);
			}
		});
	}

	private executeCallbacks($item) {
		for (const callbackObject of this.fnCallbacksOpen) {
			if (callbackObject.$ctx.closest($item).length > 0) {
				callbackObject.fnCallback();
			}
		}
	}

	private openAccordionItem(ev: JQuery.Event & { currentTarget? }) {
		const $item = $(ev.currentTarget);
		$item.closest(Selectors.AccordionItem).addClass(States.ItemOpen);
		this.$ctx.addClass(States.Open);

		this.executeCallbacks($item);
	}

	private closeAccordionItem(ev: JQuery.Event & { currentTarget? }) {
		const $item = $(ev.currentTarget);
		$item.closest(Selectors.AccordionItem).removeClass(States.ItemOpen);
		this.$ctx.removeClass(States.Open);
		for (const callbackObject of this.fnCallbacksClose) {
			if (callbackObject.$ctx.closest($item).length > 0) {
				callbackObject.fnCallback();
			}
		}
	}
}
